import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiEye, FiAlertCircle } from 'react-icons/fi';
import { CustomerCenterService } from "../../../services";
import arrowLeft from '../../../assets/img/icon/arrow-left.svg';
import arrowRight from '../../../assets/img/icon/arrow-right.svg';
import TopSetion from '../../../components/customer-service-center/TopSetion';
import SubHeading from '../../../components/customer-service-center/SubHeading';
import { formatDateToYYYYMMDD } from '../../../utils/dateUtils';


const AnnouncementDetails = () => {
    const navigate = useNavigate();
    const [announcementDetail, setAnnouncementDetail] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { id } = useParams();

    const fetchAnnouncementData = async () => {
        try {
            setLoading(true);
            const apiData = await CustomerCenterService.getAnnouncementById(id);

            if (apiData && apiData.current) {
                // Ensure previous and next fields are properly set
                apiData.previous = apiData.previous || null;
                apiData.next = apiData.next || null;

                setAnnouncementDetail(apiData);
            } else {
                setError('공지사항을 찾을 수 없습니다.');
            }
        } catch (err) {
            console.error('Failed to fetch announcements:', err);
            setError('공지사항 데이터를 불러오는데 실패했습니다.');
        } finally {
            setLoading(false);
        }
    };

    // Simulate API call
    useEffect(() => {
        fetchAnnouncementData();
    }, [id]);


    const handleNavigationClick = (direction) => {
        if (!announcementDetail) return;

        const targetArticle = direction === 'prev' ? announcementDetail.previous : announcementDetail.next;

        if (targetArticle && targetArticle.id) {
            // Set loading state for better UX
            setLoading(true);
            // Navigate to the previous/next article
            navigate(`/announcements/${targetArticle.id}`);
        }
    };

    return (
        <>
            <div className="announcement-list-page">
                <TopSetion />
                {/* Main Content */}
                <main className="main-content">
                    <SubHeading heading="공지사항" />

                    {/* Announcement Details Section */}
                    {loading ? (
                        <section className="announcement-details-section">
                            <div className="loading-container">
                                <div className="loading-spinner"></div>
                                <p>공지사항을 불러오는 중...</p>
                            </div>
                        </section>
                    ) : error ? (
                        <section className="announcement-details-section">
                            <div className="error-container">
                                <FiAlertCircle size={48} className="error-icon" />
                                <p>{error}</p>
                                <button
                                    className="retry-button"
                                    onClick={() => window.location.reload()}
                                >
                                    다시 시도
                                </button>
                            </div>
                        </section>
                    ) : announcementDetail ? (
                        <>
                            <section className="announcement-details-section">
                                {/* Article Header */}
                                <div className="article-header">
                                    <h2 className="article-title">{announcementDetail.current.boardTitle}</h2>
                                    <div className="article-meta">
                                        <span className="article-date">{formatDateToYYYYMMDD(announcementDetail.current.registTime)}</span>
                                        <div className="article-views">
                                            <FiEye size={14} className="eye-icon" />
                                            <span>{announcementDetail.current.boardReadCount}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="divider"></div>

                                {/* Article Content */}
                                <div className="article-content">
                                    <div className="article-text">
                                        <p dangerouslySetInnerHTML={{ __html: announcementDetail.current.boardContents }} />
                                    </div>
{/* 
                                    {announcementDetail.current.attachments && (
                                        <div className="article-image">
                                            <div className="content-image-placeholder">
                                                <img src={announcementDetail.current.attachments} alt="announcement-image" />
                                            </div>
                                        </div>
                                    )} */}
                                </div>


                                {/* Article Navigation */}
                                <div className="article-navigation">
                                    <div
                                        className={`nav-item prev-article ${!announcementDetail.previous ? 'disabled' : ''}`}
                                        onClick={() => handleNavigationClick('prev')}
                                    >
                                        <div className="nav-arrow prev-arrow">
                                            <img src={arrowLeft} alt="arrow-left" />
                                        </div>
                                        <div className="nav-content">
                                            <span className="nav-label">이전글</span>
                                            <span className="nav-title">
                                                {announcementDetail.previous ? announcementDetail.previous.title : '이전 글이 없습니다'}
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className={`nav-item next-article ${!announcementDetail.next ? 'disabled' : ''}`}
                                        onClick={() => handleNavigationClick('next')}
                                    >
                                        <div className="nav-content">
                                            <span className="nav-label">다음글</span>
                                            <span className="nav-title">
                                                {announcementDetail.next ? announcementDetail.next.title : '다음 글이 없습니다'}
                                            </span>
                                        </div>
                                        <div className="nav-arrow next-arrow">
                                            <img src={arrowRight} alt="arrow-right" />
                                        </div>
                                    </div>
                                </div>

                                {/* List Button */}
                                <div className="list-button-container">
                                    <button
                                        className="list-button"
                                        onClick={() => navigate('/announcements')}
                                    >
                                        목록
                                    </button>
                                </div>
                            </section>


                        </>
                    ) : null}

                </main>
            </div>
        </>
    );
};

export default AnnouncementDetails;